import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import JobsTable from './JobsTable'
import '../../assets/css/requisition.css'
import requisitionStyle from '../../assets/jss/requisitionStyle'
import { withStyles, Button, OutlinedInput, MenuItem } from '@material-ui/core'
import { 
    getJobsList,
    getPrevJobsList,
    deleteJob,
    activeJob
} from '../../actions/JobActions'
import {
    logout
} from '../../actions/LoginAction'
import * as Sentry from '@sentry/browser'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    InputLabel,
    Select
} from '@material-ui/core'
import InformationDialog from '../../components/Dialog/InformationDialog'
import ActivateJobDialog from '../../components/Dialog/Dialog'
import {
    NavLink,
    Redirect
} from 'react-router-dom'
import {
    ROUTE_REQUISITION_LIST,
    ROUTE_ADMIN_CV,
    ROUTE_ADMIN_JOB,
    ROUTE_ADMIN_LOGIN,
    ROUTE_ADMIN_CREATE_JOB,
} from '../../utils/routes'


Sentry.init({
   dsn: "https://8b7fd3762e754bab8c1c1e62dd17f0db@sentry.io/1388765"
});

class AdminJobs extends Component {

    constructor() {
        super();
        this.state = {
          job_type: 'active',
          page_index: 1,
          open_confirm_dialog: false,
          delete_title: "",
          job_status: false,
          etag: "",
          job_id: "",
          open: false,
          activate_job_dialog_open: false,
          activate_job: {}
        }
    }

    componentWillMount() {
        this.props.getJobsList(1)
    }

    componentDidCatch(error, errorInfo) {
        Sentry.withScope(scope => {
          Object.keys(errorInfo).forEach(key => {
            scope.setExtra(key, errorInfo[key]);
          });
          Sentry.captureException(error);
        });
    }

    render() {
        
        const { classes, jobs } = this.props

        if(jobs.unauthorize){
            return (
                <Redirect from={ROUTE_ADMIN_JOB} to={ROUTE_ADMIN_LOGIN}/>
            )
        }
       
        return(
            <div className={classes.main}>
                <div className="Content">

                <InformationDialog
                    open={this.state.open}
                    handleClose={this.handleClose}
                    handleLogout={this.handleLogout}
                />

                <ActivateJobDialog
                    title="Job Activation"
                    message="Are you sure want to activate this job?"
                    open={this.state.activate_job_dialog_open}
                    handleClose={this.handleCloseJobActivationDialog}
                    handleOk={this.confirmJobActivation}
                />

                <div className="CvBtn">

                    <NavLink from={ROUTE_ADMIN_JOB} to={ROUTE_REQUISITION_LIST}>
                        <Button className={classes.nav_button} variant="outlined" color="secondary">
                            View Requisitions
                        </Button>
                    </NavLink>
                    <NavLink disabled={true} from={ROUTE_ADMIN_JOB} to={ROUTE_ADMIN_JOB}>
                        <Button disabled={true} className={classes.nav_button} variant="outlined" color="secondary">
                            View Jobs
                        </Button>
                    </NavLink>
                    <NavLink  from={ROUTE_ADMIN_JOB} to={ROUTE_ADMIN_CREATE_JOB}>
                        <Button variant="outlined" className={classes.nav_button}  color="secondary">
                                    Create Job
                        </Button>
                    </NavLink>
                    <NavLink from={ROUTE_ADMIN_JOB} to={ROUTE_ADMIN_CV}>
                        <Button className={classes.nav_button} variant="outlined" color="secondary">
                            View CVs
                        </Button>
                    </NavLink>

                    <Button 
                        onClick={() => this.onLogout()}
                        variant="outlined" 
                        className={classes.nav_button} 
                        color="secondary">
                        Logout
                    </Button>
                    
                </div>

                <div>
                    <FormControl variant="outlined">

                        <InputLabel htmlFor="outlined-age-simple">
                            Job Type
                        </InputLabel>

                        <Select
                            value={this.state.job_type}
                            onChange ={this.handleChange} 
                            input = {<OutlinedInput labelWidth={60} name="job-type" id="outlined-age-simple" />}
                        >
                            <MenuItem value= 'active'> Active Job</MenuItem>
                            <MenuItem value= 'inactive'> Old Job</MenuItem>
                        </Select>

                    </FormControl>
                </div>

                    <JobsTable
                        tableHeadColor = "primary"
                        tableHead = {["Title", "Department","Entity", "Status", "Created Date", "Close Date", "Detail", "Delete", "Activation"]}
                        tableData = {jobs.list}
                        openConfirmDialog= {this.handleOpenDialog}
                        handleJobActivation={this.handleJobActivation}          
                    />

                    <Dialog
                        open={this.state.open_confirm_dialog}
                        onClose={this.handleClose}
                        aria-labelledby="responsive-dialog-title"
                    >
                    <DialogTitle id="responsive-dialog-title">{"Delete this job?"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {
                                    this.state.delete_title+" is currently "

                                }
                                {
                                    this.state.job_status ? " active. Are you sure want to delete this job?":" inactive. Are you sure want to delete this job?"
                                }
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.handleDeleteJob} color="primary" autoFocus>
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <GridContainer>

                        <GridItem xs={12} sm={12} md={6}>
                            <Button
                                className={classes.next_button}
                                color="secondary"
                                variant="contained"
                                disabled={this.state.page_index === 1} 
                                onClick={() => this.handlePrev()}>
                                Prev Page
                            </Button>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={6}>
                            <div className="PageButton">
                                <Button 
                                    className={classes.next_button}
                                    disabled={this.props.jobs.list.length < 20}
                                    color="secondary"
                                    variant="contained"
                                    onClick={() => this.handleNext()}>
                                    Next Page
                                </Button>
                            </div>
                        </GridItem>

                    </GridContainer>
                </div>
            </div>
        )
    }

    handleChange = (event) => {

        this.setState({
            job_type: event.target.value,
            page_index: 1
        })

        if(event.target.value === 'active'){
            this.props.getJobsList(1)
        }else{
            this.props.getPrevJobsList(1)
        }

    }

    handleOpenJobActivationDialog = () => {
        this.setState({
            activate_job_dialog_open: true
        })
    }

    handleCloseJobActivationDialog = () => {
        this.setState({
            activate_job_dialog_open: false
        })
    }

    handleJobActivation = (prop) => {
       this.setState({
           activate_job: prop,
           activate_job_dialog_open: true
       })
    }

    confirmJobActivation = () => {

        this.setState({
            activate_job_dialog_open: false
        })

        this.props.activeJob({page_index: this.state.page_index, job: this.state.activate_job })
    }

    onLogout = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleLogout = () => {
        this.setState({
            open: false
        })
        this.props.logout()
        this.props.history.replace(ROUTE_ADMIN_LOGIN, { firstPage: true});
       // this.props.history.push(ROUTE_ADMIN_LOGIN);
    }

    handleNext = () => {

        this.setState( state => ({
            page_index: state.page_index + 1
        }))
        if(this.state.job_type === 'active'){
            this.props.getJobsList(this.state.page_index + 1)
        }else{
            this.props.getPrevJobsList(this.state.page_index + 1)
        }
        
    }

    handlePrev = () => {

        if(this.state.page_index > 1) {
            this.setState( state => ({
                page_index: state.page_index - 1
            }))
        }

        if(this.state.job_type === 'active'){
            this.props.getJobsList(this.state.page_index - 1)
        }else{
            this.props.getPrevJobsList(this.state.page_index - 1)
        }
        
    }

    handleOpenDialog = (props) => {

        this.setState({
            open_confirm_dialog: true,
            delete_title: props.title,
            job_status: props.active,
            etag: props._etag,
            job_id: props._id
        })

    }

    handleClose = () => {
        this.setState({
            open_confirm_dialog: false
        })
    }

    handleDeleteJob = () => {

        this.setState({
            open_confirm_dialog: false
        })

        this.props.deleteJob({_etag: this.state.etag, _job_id: this.state.job_id, page_index: this.state.page_index})
    }

}

AdminJobs.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = (dispatch) => ({
    getJobsList: (page_index) => {
        dispatch(
            getJobsList(page_index)
        )
    },
    getPrevJobsList: (page_index) => {
        dispatch(
            getPrevJobsList(page_index)
        )
    },
    deleteJob: (props) => {
        dispatch(
            deleteJob(props)
        )
    },
    activeJob: (props) => {
        dispatch(
            activeJob(props)
        )
    },
    logout: () => {
        dispatch(
            logout()
        )
    }
  })
  
const mapStateToProps = state => ({
    jobs: state.jobs
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(requisitionStyle) (AdminJobs))

